/**
 * This file will configure various resources for your application.
 * - Logging to NewRelic (More configuration required - see below)
 * - Analytics tracking through Adobe Target Events
 * - Daxi (The Origin Digital http request library)
 *
 * Anything else required before your app is loaded can be included in this
 * file.
 */

import { configFetch, configFetchCache } from "@origin-digital/daxi";
import {
  configAnalytics,
  configNewRelic,
} from "@origin-digital/reporting-client";

import { appName, config } from "./config";

const envAppName = `${appName}-${config.env}`;

declare const __DEV__: boolean;

declare global {
  interface Window {
    // @ts-ignore
    oetal: any;
    __BASEPATH__: string;
  }
}

// @ts-ignore
window.__BASEPATH__ = __DEV__ ? "" : window.oetal.pageData.route;

configAnalytics({
  appName,
  debugToConsole: config.analyticsDebugToConsole,
});

configNewRelic({
  appName: envAppName,
  consoleLogLevel: config.logLevelConsole as LogLevel,
  endpoint: config.newRelicEndpoint,
  apiKey: config.newRelicApiKey,
  sendOnErrors: config.newRelicSendOnErrors,
  sourceEnv: config.env as EnvironmentNames,
  logLevel: config.logLevelNewRelic as LogLevel,
});

configFetch({
  environment: config.env,
  disableAuthCheck: __DEV__,
});

configFetchCache({ disableCache: __DEV__ });
